import { InstructionCounts } from 'app/src/engine/Instruction';
import MovableItem, { MovableItemLocation } from 'app/src/engine/movable-items/MovableItem';
import Robot from 'app/src/engine/movable-items/Robot';
import Star from 'app/src/engine/Star';
import Tile from 'app/src/engine/tiles/Tile';
import GamePlugin from 'app/src/plugins/GamePlugin';

export type LevelDescription = {
	title: string;
	description: string;

	tiles: Tile[][];

	stars: Set<Star>;

	robots: Set<Robot>;
	robotLocations: Map<Robot, MovableItemLocation>;

	movableItems: Set<MovableItem>;
	movableItemLocations: Map<MovableItem, MovableItemLocation>;

	gamePlugins: Set<GamePlugin>;

	instructionCounts: InstructionCounts;
};

export function cloneLevelDescription(levelDescription: LevelDescription): LevelDescription {
	const stars = new Set(Array.from(levelDescription.stars).map((star) => star.clone()));

	const tiles = levelDescription.tiles.map((row) => row.map((tile) => tile.clone()));

	const robots: Set<Robot> = new Set();
	const robotLocations: Map<Robot, MovableItemLocation> = new Map();

	for (const robot of Array.from(levelDescription.robots)) {
		const clone = robot.clone();
		robots.add(clone);
		robotLocations.set(clone, { ...levelDescription.robotLocations.get(robot)! });
	}

	const movableItems: Set<MovableItem> = new Set();
	const movableItemLocations: Map<MovableItem, MovableItemLocation> = new Map();

	for (const movableItem of Array.from(levelDescription.movableItems)) {
		const clone = movableItem.clone();
		movableItems.add(clone);
		movableItemLocations.set(clone, { ...levelDescription.movableItemLocations.get(movableItem)! });
	}

	return {
		title: levelDescription.title,
		description: levelDescription.description,
		tiles,
		stars,
		robots,
		robotLocations,
		movableItems,
		movableItemLocations,
		gamePlugins: levelDescription.gamePlugins,
		instructionCounts: new Map(levelDescription.instructionCounts),
	};
}
